import { render, staticRenderFns } from "./SearchesPanel.vue?vue&type=template&id=738565e2&scoped=true"
import script from "./SearchesPanel.vue?vue&type=script&lang=js"
export * from "./SearchesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738565e2",
  null
  
)

export default component.exports